import { IconButton } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useDownloadPdfFiles } from 'shared/mutations/pdf-download-mutation';
import { addPdfExtension } from 'shared/utility';

export function DownloadFileColumn({
  value: contractId,
  row: { original },
}: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const pdfDownloadMutation = useDownloadPdfFiles();

  return (
    <IconButton
      color='primary'
      aria-label='download contract'
      title='Download Contract File'
      onClick={async () => {
        await pdfDownloadMutation.mutateAsync({
          fileId: addPdfExtension(contractId),
          originalFileName: original.originalDocumentName,
        });
      }}
    >
      <OpenInNewIcon color='secondary' />
    </IconButton>
  );
}
